<script>
import Layout from "../../layouts/main";
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import BannerApi from "@/services/banner-api";
import highlightsDist from "@/components/highlightsNews-dist";
import highlightsSmallDist from "@/components/highlights-dist";
import ClaimApi from "@/services/claim-api";

export default {

  components: {
    Layout, highlightsDist, highlightsSmallDist
  },
  data() {
    return {

      contactUs:{ name: '' , mail: '' , message:''},
      counterVisible: false,
      keyCounterVisible:0,

      mediaFeaturesVisible: false,
      iconsVisible: false,

      bannerList: [],
      icons: [
        { imgSrc: 'car-3-svgrepo-com', altText: 'default.icons.1.altText', text: 'default.icons.1.text' },
        { imgSrc: 'family-of-3-whole-body-svgrepo-com', altText: 'default.icons.2.altText', text: 'default.icons.2.text' },
        { imgSrc: 'plane-svgrepo-com', altText: 'default.icons.3.altText', text: 'default.icons.3.text' },
        { imgSrc: 'tray-dish-svgrepo-com', altText: 'default.icons.4.altText', text: 'default.icons.4.text' }
      ],

      referencesLogos: [
        
      ],

      isBannerTableBusy: false,
      mediaFeatures: [
      {
        id: "1",
        icon: "box-dist",
        alt: "Catalogue",
        title: "Gestion des stocks",
        description: "Assure la disponibilité et l’accès aux médicaments et aux produits parapharmaceutiques."
      },
      {
        id: "2",
        icon: "on-line-dist",
        alt: "Commandes en ligne",
        title: "Commande en ligne",
        description: "Grâce a la Plateforme  la gestion de l’officine est facilitée."
      },
      {
        id: "3",
        icon: "truck-dist",
        alt: "Services de distribution",
        title: "Services de distribution",
        description: "Un réseau de distribution efficace pour assurer une livraison dans les meilleurs délais."
      },
     
      ],


     contactItems: [
        {
          "title": "Téléphone",
          "icon": "phone-dist",
          "details": {
            "tunis": "70-250-280",
            "kairouan": "70-555-900"
          }
        },
        {
          "title": "E-mail",
          "icon": "mail-dist",
          "details": {
            "tunis": "distrimedtunis@gmail.com",
            "kairouan": "distrimedkairouan@yahoo.fr"
          }
        },
        {
          "title": "Emplacement",
          "icon": "position-dist",
          "details": {
            "tunis": "01 Rue Fer zone industrielle Sidi Daoud La Marsa",
            "kairouan": "zone industrielle 01 route de Tunis"
          }
        },
        {
          "title": "Horaires",
          "icon": "clock-dist",
          "details": {
            "days": "Lundi - Dimanche",
            "time": "8:00 AM - 10:00 PM"
          }
        }
      ],

    

      counterItems: [
        {
          width: '70px',
          moreThanText: 'En Tunisie',
          endVal: 2,
          duration: 1000,
          title: 'Grandes Agences ',
        },
        {
          width: '70px',
          moreThanText: 'plus de',
          endVal: 2000,
          duration: 3000,
          title: 'Pharmacies clientes',
        },
        {
          width: '70px',
          moreThanText: 'plus de',
          endVal: 31600,
          duration: 3000,
          title: 'Produits disponibles',
        }
      ]


    };
  },

  computed: {
    windowWidth() {
      return window.innerWidth;
    },

    customerPortalName(){
      return process.env.VUE_APP_CUSTOMER_PORTAL_NAME
    },

    vueAppCustomerInfo() {
      const vueAppCustomerInfo = {
        address: process.env.VUE_APP_CUSTOMER_ADDRESS,
        email: process.env.VUE_APP_CUSTOMER_EMAIL,
        phone: process.env.VUE_APP_CUSTOMER_PHONE,
      };

      return vueAppCustomerInfo;
    },

  },

  watch:{

    iconsVisible(newValue){
      if(newValue){
      this.observeIcons()
      }
    },

    counterVisible(newValue) {
      if (newValue) {
        this.keyCounterVisible ++
      }
    }
  },

  mounted() {
    this.findBanner(this.windowWidth);
  },

  methods: {

    sendContactUsMail(){
      ClaimApi.sendContactUsMail(this.contactUs).then((result) => {
        if(result){
          this.contactUs={ name: '' , mail: '' , message:''}
        }
      })
    },

    findBanner(windowWidth) {
      this.isBannerTableBusy = true;
      BannerApi.getBanners(windowWidth).then((result) => {
        this.bannerList = result;
        
      }).finally(() => {
        this.isBannerTableBusy = false;
      })
    },

  }
};
</script>

<template>
  <Layout class="default-dist-layout" id="accueil">

    <!-- Main Banners -->
    <div class="row pt-xl-0 " >
      <!-- <div class="col-xl-9 col-sm-12 col-md-8" > -->
      <div class="col-12" >
        <div class="p-0" >
            <b-carousel
              style="box-shadow:0 2px 6px 0 rgb(0 0 0 / 8%);"
                img-width="1920"
                img-height="400" 
                :interval="6000"
                

                :controls="false"
                :indicators="false"
                :no-hover-pause="false"
                :no-touch="false"
                :fade="true">

                <b-carousel-slide class="bg-light"  
                          style="width:1920px; height:565px;" 
                          img-blank img-alt="Blank Image " 
                          img-width="1900"
                img-height="400" 
                          v-if="isBannerTableBusy || !bannerList || !bannerList.length">
                  <!-- <p class="text-secondary">
                    caption="Restez à l'écoute!" 
                    Les publicitées seront disponibles prochainement
                  </p> -->

                </b-carousel-slide> 

                <b-carousel-slide v-for="banner in bannerList" :key="banner.id">
                  <template #img>
                    <img :src="'/api/banner/get/' + banner.generatedName" alt="Banner Image" class="banner-image" width="100%" height="100%">
                  </template>
                

                  <div>

                  

                  </div>

                </b-carousel-slide>
                

                <div class="carousel-title-caption justify-content-between align-items-center text-white p-3 d-none d-md-flex">
                  
                  <div class="div-title">
                    <h2 class="banner-title mb-0" >DISTRI-MED</h2>
                  </div>

                </div>

                <div class="carousel-caption justify-content-between align-items-center text-white p-3 d-none d-md-flex">
                  
                  <div class="">
                  </div>

                  <a href="/catalogue" class="text-decoration-none ms-3">
                    <div class="start-button px-4 py-2">Commencer</div>
                  </a>
                </div>

                
              
            </b-carousel>



        </div>
      </div>


    </div>


    <div class="text-white text-center p-3 d-md-none">

      <div class="mt-3 text-center">
        <a href="/catalogue" class="text-decoration-none d-flex justify-content-center">
          <div class="start-button ">Commencer</div>
        </a>
      </div>
    </div>



    <!-- 5 points section -->
    <div class="pt-4 pb-4 text-center bg-white " id="services"> 
      
      <div class="services-class" >
        Services
      </div>

      <div class="header-60-width services-desc-class" >
        Distri-Med est un grossiste répartiteur de la chaine de distribution pharmaceutique en Tunisie
      </div>


    </div>

   


  <div class="bg-white pt-md-5 pt-3 pb-5">
    <div ref="mediaFeaturesSection" class="row pt-md-4 pt-1 text-center justify-content-center">
      <div
        v-for="(feature, index) in mediaFeatures"
        :key="feature.id"
        class="col-md-4 col-sm-6 col-12 mb-5 d-flex justify-content-center"
        :style="{ animationDelay: (index * 0.05) + 's' }"
        ref="mediaFeatureElements"
      >
        <div class="feature-card position-relative text-center">
          <!-- Icon floating above -->
          <div class="feature-icon position-absolute translate-middle">
            <img
              :src="require('@/assets/images/' + feature.icon + '.svg')"
              :alt="feature.alt"
              width="70"
              height="70"
            />
          </div>

          <!-- Content -->
          <div class="pt-3 ">
            <h5 class="font-weight-bold text-dark mb-3" style="font-size: 26px;">{{ feature.title }}</h5>
            <p class="feature-desc">{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>



    <div class="row bg-white">

      <div class="col-12">
        <highlightsSmallDist :propDisplayTitle="true" class="" />
      </div>
  </div>





  <div class="values-section text-white py-5" id="values">

    <div class="cercleDiv" />
    <div class="cercleDiv1  d-none d-md-block" />

    <!-- Header -->
    <div class="header-60-width text-center mb-5">
      <h2 class="values-section-title mt-4">Nos chiffres</h2>

        <div class=" mt-5 mb-5" style="height: 4.7px; background: #E9E9E9; box-shadow: 0px 4px 3.2px 0px #0000007D; border-radius: 100px;" ></div>

      <p class="values-section-desc mt-5">
        Centre de distribution pharmaceutique le plus fiable
      </p>
    </div>
    <!-- Cards Section -->
    <div class="header-80-width mb-5">
      <div class="row justify-content-center">
        
        <!-- Card 1: Produits -->
        <div class="col-12 col-md-4 mb-md-0 mb-2 ">
          <div class="card card-value h-100 text-center p-4 m-4 text-white rounded-lg shadow">
            <h1 class="display-4 font-weight-bold mb-3">10,000+</h1>
            <p class="display-5 mb-1">Produits</p>
            <p class="display-6 small">Références disponibles</p>
          </div>
        </div>

        <!-- Card 2: Années d'expérience -->
        <div class="col-12 col-md-4 mb-md-0 mb-2 mt-md-0 mt-2">
          <div class="card card-value h-100 text-center p-4 m-4 text-white rounded-lg shadow">
            <h1 class="display-4 font-weight-bold mb-3">18+</h1>
            <p class="display-5 mb-1">Années d'expérience</p>
            <p class="display-6 small">Au service de la santé</p>
          </div>
        </div>

        <!-- Card 3: Partenaires -->
        <div class="col-12 col-md-4 mt-md-0 mt-2">
          <div class="card card-value h-100 text-center p-4 m-4 text-white rounded-lg shadow">
            <div class="cercleDiv2 d-none d-md-block" />
            <div class="cercleDiv3" />

            <h1 class="display-4 font-weight-bold mb-3">500+</h1>
            <p class="display-5 mb-1">Partenaires</p>
            <!-- <p class="display-6 small">Commandes traitées mensuellement</p> -->
          </div>
        </div>

      </div>
    </div>
  </div>

      <highlightsDist :propDisplayTitle="true" />




      <div class="pt-4 pb-4 text-center bg-white " id="contact">
      
      <div class="services-class">
        Contactez-nous
      </div>

      <div class="header-60-width services-desc-class" >
        Des questions sur nos services ? Notre équipe est là pour vous aider.
      </div>


    </div>


     <div class="row  m-4">
      <div v-for="(item, index) in contactItems" :key="index" class="col-lg-3 col-md-6 col-sm-12 mb-lg-0 mb-4 ">
        <div class="contact-item m-3 h-100">
             <img
              :src="require(`@/assets/images/${item.icon}.svg`)"
              :alt="item.title"
              class="img-fluid"
              width="40"
              height="40"
            />

          <h3 class="contact-title mt-3">{{ item.title }}</h3>
          <div v-if="item.details.tunis || item.details.kairouan" class="contact-details">
            <div>Tunis: {{ item.details.tunis }}</div>
            <div>Kairouan:  {{ item.details.kairouan }}</div>
          </div>
          <div v-else class="contact-details">
            <div>Jours: {{ item.details.days }}</div>
            <div>Heures: {{ item.details.time }}</div>
          </div>
        </div>
      </div>
    </div>





   <div class="row align-items-center " style="margin: auto; max-width: 80%; min-height: 100vh;">
      <div class="col-md-6 col-12">
        <h2 class="text-dark font-size-20 mb-4">Envoyez-nous un message</h2>

        <label class="mb-2" for="nom">Nom</label>
        <input
          style="background-color: #E9E9E9; color: white;"
          class="form-control"
          id="nom"
          v-model="contactUs.name"
          type="text"
          autocomplete="off"
        />

        <label class="mb-2 mt-4" for="mail">E-mail</label>
        <input
          style="background-color: #E9E9E9; color: white;"
          class="form-control"
          id="mail"
          v-model="contactUs.mail"
          autocomplete="off"
        />

        <label class="mb-2 mt-4" for="message">Message</label>
        <textarea
          style="background-color: #E9E9E9; color: white;"
          class="form-control"
          id="message"
          rows="5"
          v-model="contactUs.message"
          autocomplete="off"
        ></textarea>

        <h2 class="submit-button div-submit w-100 text-center text-white mb-0 mt-2" @click="sendContactUsMail">
          Soumettre
        </h2>
      </div>

      <div class="col-md-6 col-12 justify-content-center align-items-center d-none d-md-flex p-3">
        <img
          src="@/assets/images/dist/dist-default-image.png"
          alt="Contact Us"
          class="img-fluid m-4"
          style="height: 100%; width: auto;"
        />
      </div>
    </div>




        <div class="mt-2 mt-md-5 footer-section">
          <div class="row  " style="letter-spacing: 0.01em ">
            <div class="col-12"> 

              <div class="row pb-1">

                <div class="logo-card col-xl-2 col-md-3 col-sm-12 text-md-left pr-2 text-left d-none d-md-block">
                  <div class="d-flex align-items-center justify-content-center h-100 logo-card-img">
                    <img src="@/assets/images/dist/logo2.png" alt="Logo Dist" width="166" height="auto" />
                  </div>
                </div>

                <div class="col-xl-10 col-md-9 col-sm-12 pl-2 d-flex align-items-center mt-4 mb-4">
                  <div class="w-100">
                    <div class="row d-flex justify-content-between">
                      <div class="col-lg-1 col-md-4 col-sm-12 p-2 text-left pt-md-0 pt-4"/>

                      <div class="col-lg-9 mb-3">
                        <div class="row d-flex justify-content-between">
                          <div class="col-xl-3 col-md-4 col-sm-12 p-2 text-left pt-md-0 pt-4">
                            <h5 class="footer-section-title">Liens rapides</h5>
                            <ul class="mt-4 list-unstyled ">
                              <li >
                                <a class="footer-section-link" href="#accueil" >Accueil</a>
                              </li>
                              <li >
                                <a class="footer-section-link" href="#services" >Services</a>
                              </li>
                              <li >
                                <a class="footer-section-link" href="#values" >Chiffres</a>
                              </li>
                              <li >
                                <a class="footer-section-link" href="/claim">Réclamation</a>
                              </li>
                              <li>
                                <a class="footer-section-link" href="#contact" >Contact</a>
                              </li>
                            </ul>
                          </div>

                          <div class="col-xl-3 col-md-4 col-sm-12 p-2 text-left pt-md-0 pt-4">
                            <h5 class="footer-section-title">Produits</h5>
                            <ul class="mt-4 list-unstyled">
                              <li>
                                <a class="footer-section-link" href="/catalogue">Tout le catalogue</a>
                              </li>
                              <li>
                                <a class="footer-section-link" href="/catalogue">Produits Pharmaceutiques</a>
                              </li>
                              <li>
                                <a class="footer-section-link" href="/catalogue">Produits Parapharmaceutiques</a>
                              </li>
                            </ul>
                          </div>

                          <div class="col-xl-3 col-md-4 col-sm-12 p-2 text-left pt-md-0 pt-4">
                            <h5 class="footer-section-title">Espace client</h5>
                            <ul class="mt-4 list-unstyled ">
                              <li >
                                <a class="footer-section-link" href="/profil">Profil Utilisateur</a>
                              </li>
                              <li >
                                <a class="footer-section-link" href="/commandes">Commandes</a>
                              </li>
                              <li>
                                <a class="footer-section-link" href="/claim">Réclamation</a>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div class="mt-2 mb-2" style=" height: 3px; background: #fff; border-radius: 100px;" ></div>
                        <div class=" font-size-22 text-white font-weight-bold text-center  mt-3 mb-2" style="font-weight: 400; line-height: 25px"  >© {{ new Date().getFullYear() }} Distri-Med Groupe. Tous droits réservés</div>

                        
                      </div>

                      <div class="col-lg-2 d-flex align-items-end justify-content-end  mb-md-3 mb-5">
                      </div>

                      <!-- <div class="col-xl-2 col-md-4 col-sm-12 p-2 text-left pt-md-0 pt-4"/> -->
                    
                    
                    </div>





                  </div>



                </div>

              </div>
            </div>
          </div>
        </div>


    

   

  </Layout>
</template>

<style scoped>

.start-button {
  width: 148px;
  height: 53px;
  opacity: 1;
  border-radius: 28px;
  background: linear-gradient(90deg, #00BC7C 0%, #00CAC8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
}


.div-title{
  border-top-right-radius: 104px;
  border-bottom-right-radius: 104px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  background: #363D474D;
  padding: 70px 20px 70px 10px;

}

.banner-title {
  font-weight: 900;
  font-style: Condensed Black;
  font-size: 100px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #fff;
}

.banner-small-title {
  font-weight: 900;
  font-style: Condensed Black;
  font-size: 40px;
  line-height: 35px;
  text-align: center;
  vertical-align: middle;

}


.carousel-title-caption {
  position: absolute;
  padding-left: 5%;
  top: 13%;
  left: 0;
  transform: translateY(-50%);
  z-index: 2;
  width: 100%;
  height: 100%;
}


.carousel-caption {
  position: absolute;
  padding-left: 5%;
  top: 94%;
  left: 0;
  transform: translateY(-50%);
  z-index: 2;
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .carousel-caption {
    position: absolute;
    padding-left: 5%;
    top: 30%;
    left: 0;
    transform: translateY(-50%);
    z-index: 2;
  }
}


.services-class {
  margin-top: 25px;
  font-weight: 900;
  font-size: 53px;
  line-height: 64px; /* augmenté pour correspondre à la hauteur de texte */
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;

  background: linear-gradient(90deg, #00BC7C 0%, #00CAC8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}


.services-desc-class {
  padding-top: 35px;
  font-weight: 400;
  font-size: 32.6px;
  line-height: 40px;
  text-align: center;
  vertical-align: middle;
  color: #737373;
}

.header-60-width {
  max-width: 80%;
  margin: auto;
}

@media (min-width: 768px) {
  .header-60-width {
      max-width: 50%;
  }
}


.header-80-width {
  max-width: 90%;
  margin: auto;
}

@media (min-width: 768px) {
  .header-80-width {
      max-width: 80%;
  }
}

.feature-card {
  background-color: #CFC8C3;
  border-radius: 20px;
  width: 100%;
  max-width: 350px;
  min-height: 250px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 40px 20px 0px 20px;
}

.feature-icon {
  transform: translateY(-75px);
}

.feature-desc{
  margin-top: 25px ;
  font-weight: 400;
  font-size: 20px;
  line-height: 35px;
  text-align: center;
  vertical-align: middle;

}

.buttons-section{
  justify-content: space-around;
}

.div-button {
  background: linear-gradient(270deg, #00BC7C 0%, #00CAC8 100%);
  border-radius: 120.5px;
  padding: 50px 60px 50px 60px;

}

.div-button2 {
  background: linear-gradient(270deg, #00BC7C 0%, #00CAC8 100%);
  border-radius: 10px;
  padding: 25px 40px 25px 40px;
  box-shadow: 0px 4px 6px 4px rgba(0, 0, 0, 0.1);

}

.submit-button {
  cursor: pointer;
  background: linear-gradient(270deg, #00BC7C 0%, #00CAC8 100%);
  border-radius: 120.5px;
  padding: 50px 60px 50px 60px;

}

.div-submit {
  background: linear-gradient(270deg, #00BC7C 0%, #00CAC8 100%);
  border-radius: 10px;
  padding: 15px 20px 15px 20px;
  box-shadow: 0px 4px 6px 4px rgba(0, 0, 0, 0.1);

}

.button-title {
  cursor: pointer;
  font-weight: 700;
  font-style: Bold;
  font-size: 35px;
  line-height: 40px;
  vertical-align: middle;
  color: #fff;
}


.button-title2 {
  cursor: pointer;
  font-weight: 500;
  font-size: 25px;
  line-height: 30px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
}



.values-section {
  position: relative;
  overflow: hidden;
  background-color:  rgba(46, 60, 75, 0.8);

}

.card-value {
  background-color: rgba(80, 199, 199, 0.33);
  border-radius: 16px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.card-value:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.display-4 {
  color: white;
  font-size: 3rem;
}

.display-5 {
  color: white;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 21.25px;
  line-height: 35px;
  text-align: center;
  vertical-align: middle;
}

.display-6 {
  color: white;
  font-weight: 400;
  font-size: 14.45px;
  line-height: 25px;
  text-align: center;
  vertical-align: middle;

}

.values-section-title {
  font-weight: 900;
  font-style: Black;
  font-size: 53px;
  line-height: 24px;
  text-align: center;
  vertical-align: middle;
  color: #50C7C7;
}

.values-section-desc {
  font-weight: 400;
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  vertical-align: middle;
  color: #D4E0ED;
}

@media (max-width: 768px) {
  .display-4 {
    font-size: 2rem; /* Smaller font size for mobile */
  }
}

.contact-title {
  font-weight: 500;
  font-size: 15.3px;
  line-height: 28px;
  text-align: center;
  vertical-align: middle;
  color: #000000;
}

.contact-item {
  border: 0px solid #ccc;
  padding: 20px;
  text-align: center;
  background-color: #F9FAFB;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  opacity: 1;
  border-radius: 8px;
}

.contact-details {
  font-weight: 600;
  font-size: 13px;
  line-height: 24px;
  text-align: center;
  vertical-align: middle;
  color: #6B7280;
}

.icon {
  font-size: 2rem;
  color: #2ecc71; /* Teal color */
  margin-bottom: 10px;
}

.footer-section{
  background-color: #58636F;
}

.logo-card {
  min-height: 370px;
  background-color: #fff;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-right: 1px solid #ccc;
  border-top-right-radius: 200px;
  border-bottom-right-radius: 200px;
  transform: translateX(-40px);
}

.logo-card-img {
  transform: translateX(50px);
}

@media (max-width: 1700px) {
  .logo-card-img {
    transform: translateX(30px);
  }
}


.footer-section-title{
  font-weight: 700;
  font-size: 26px;
  line-height: 39px;
  vertical-align: middle;
  color: #32C0A6;

}

.footer-section-link{
  color: white;
  font-weight: 500;
  font-size: 20px;
  line-height: 39px;
  vertical-align: middle;

}

.default-dist-layout{
  font-family: 'Roboto', sans-serif;
}

.cercleDiv {
  position: absolute;
  transform: translate(-40%, -20%);
  width: 368px;              
  height: 368px;
  border-radius: 50%;
  background-color: #D9D9D942;  
  margin: auto;             
}

.cercleDiv1 {
  position: absolute;
  transform: translate(49%, 74%);
  width: 368px;              
  height: 368px;
  border-radius: 50%;
  background-color: #D9D9D942;  
  margin: auto;             
}

.cercleDiv2 {
  position: absolute;
  transform: translate(48%, -75%);
  width: 300px;              
  height: 300px;
  border-radius: 50%;
  background-color: #D9D9D942;  
  margin: auto;             
}

.cercleDiv3 {
  position: absolute;
  transform: translate(146%, 40%);
  width: 300px;              
  height: 300px;
  border-radius: 50%;
  background-color: #D9D9D942;  
  margin: auto;             
}

</style>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');
</style>